import React, { useContext } from "react";
import { SidebarContext } from "../../Context/SidebarContext";
import AttributeItem from "./AttributeItem";
import Loader from "../../components/Loader";




const SidebarAttributes = ({ parentAttributes, isLoadingValues, setOptions }) => {
  const { hide, isSidebarOpen } = useContext(SidebarContext) || {};
  if (!isSidebarOpen) return null;

  if (isLoadingValues) return <Loader />;

  return (
    <aside className="w-[300px] hidden md:block border-r shrink-0 pr-6 pb-10">
      <div className="flex w-full mb-3 justify-end">
        <button onClick={hide}>
          <i className="fas fa-times"></i>
        </button>
      </div>
      <ul className="flex flex-col gap-3 font-semibold text-lg pl-[20px]">
        {parentAttributes &&
        Object.keys(parentAttributes?.attributesValues || {}).length > 0
          ? Object.keys(parentAttributes?.attributesValues).map(
              (key, index) => (
                <AttributeItem
                  key={index}
                propertyName={key}
                setOptions={setOptions}
                  values={parentAttributes?.attributesValues[key]}
                  attributeName={parentAttributes?.attributesValues[key]?.name}
                  showBtn={true}
                >
                  {key}
                </AttributeItem>
              )
            )
          : null}
      </ul>
    </aside>
  );
};

export default SidebarAttributes;
